import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import getRandomNumberBetween from 'scaleflow/utils/get-random-number-between';
import ThemeValidations from 'scaleflow/validators/theme';
export default class QuickAddsThemeComponent extends Component {
  @service store;
  @service router;
  @service betaToggle;

  theme = {
    color:
      this.betaToggle.themeColorOptions[
        getRandomNumberBetween(0, this.betaToggle.themeColorOptions.length - 1)
      ].value,
    title: '',
  };
  themeValidations = ThemeValidations;

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const theme = this.store.createRecord('theme', {
        color: changeset.color,
        title: changeset.title,
      });
      await theme.save();
      this.args?.onItemSaved(theme);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }
}
